// extracted by mini-css-extract-plugin
export default {"DivContainer":"WingsCard_DivContainer__0I6Zc","InlineDiv":"WingsCard_InlineDiv__0j1YG","Title":"WingsCard_Title__p6pyJ"};